import { LOCALE_ID, Pipe, PipeTransform, inject } from '@angular/core';
import { formatDistance } from 'date-fns';
import { enUS, hu } from 'date-fns/locale';

@Pipe({
  name: 'formatDateDistance',
})
export class FormatDateDistancePipe implements PipeTransform {
  private locale = inject(LOCALE_ID);

  transform(date: string): string {
    return formatDistance(new Date(date), new Date(), {
      addSuffix: true,
      locale: this.locale === 'hu' ? hu : enUS,
    })
      .replace('minutes', 'mins')
      .replace('minute', 'min')
      .replace('seconds', 'secs')
      .replace('second', 'sec')
      .replace('órával ezelőtt', 'órája')
      .replace('nappal ezelőtt', 'napja')
      .replace('perccel ezelőtt', 'perce');
  }
}
